// eslint-disable-next-line no-restricted-syntax
export enum Routes {
	Home = '/',
	Login = '/auth',
	Logout = '/logout',
	NewTrip = '/trips/new',
	NewSearch = '/trips/:tripId/search/new',
	TripBuilder = '/trips/:tripId/search/:searchId/:mode?',
	BuildTrip = '/trips/:tripId/search/:searchId/build',
	BrowseTrip = '/trips/:tripId/search/:searchId/view',
	HotelResult = '/trips/:tripId/search/:searchId/hotel/:hotelId',
	TripProduct = '/trips/:tripId/booking/:bookingSegmentId',
	TripProductSearch = '/trips/:tripId/booking/:bookingSegmentId/search/:searchId',
	TripProductSearchWithStep = '/trips/:tripId/booking/:bookingSegmentId/search/:searchId/step/:step',
	Itinerary = '/trips/:id/itinerary',
	CreateTravelerProfile = '/profile/create',
	EditTravelerProfile = '/profile/:id/edit',
	TravelerProfileUnusedTickets = '/profile/:id/unused-tickets',
	TravelerProfileUnpaidFee = '/profile/:id/unpaid-fee',
	LiveMap = '/admin/live-map',
	Admin = '/admin',
	ManageLocations = '/admin/locations',
	ManageSso = '/admin/sso',
	ManageTravelers = '/admin/travelers',
	ManageDepartments = '/admin/departments',
	GeneralSettings = '/admin/general',
	ReportSettings = '/admin/report',
	CorporateDiscountsAndRewardPrograms = '/admin/corporate-discounts',
	CompanyPolicySettings = '/policy/company/:param0?/:param1?/:param2?',
	ExpensePolicySettings = '/policy/expense/:param0?/:param1?/:param2?',
	OfficePolicySettings = '/policy/office/:param0?/:param1?/:param2?',
	PolicyGroupSettings = '/policy/policy-group/:param0?/:param1?/:param2?',
	Reports = '/reports',
	ReportsOverview = '/reports/overview',
	ReportsFlights = '/reports/flights',
	ReportsHotels = '/reports/hotels',
	ReportsCars = '/reports/cars',
	ReportsRails = '/reports/trains',
	ReportsTravelers = '/reports/travelers',
	ReportsUnusedTickets = '/reports/unused-tickets',
	PasswordChangeResult = '/password-changed',
	Support = '/support',
	Billing = '/billing',
	Invoices = '/billing/invoices',
	BillingCurrent = '/billing/current',
	BillingUsage = '/billing/usage',
	BillingChangePlan = '/billing/change-plan',
	CreateInvoiceProfile = '/billing/profile/create',
	ActivateInvoiceProfile = '/billing/profile/:id/activate',
	Trips = '/trips/:status?/:scrollToTrip?',
	ManageExpenses = '/expenses/manage',
	NewStandardExpense = '/expenses/se/new',
	NewStandardExpenseInReport = '/expenses/reports/se/new',
	EditStandardExpense = '/expenses/se/:id/review',
	EditStandardExpenseInReport = '/expenses/reports/se/:id/review',
	NewMileage = '/expenses/mileage/new',
	NewMileageInReport = '/expenses/reports/mileage/new',
	EditMileage = '/expenses/mileage/:id/review',
	EditMileageInReport = '/expenses/reports/mileage/:id/review',
	NewDailyAllowance = '/expenses/da/new',
	NewDailyAllowanceInReport = '/expenses/reports/da/new',
	EditDailyAllowance = '/expenses/da/:id/review',
	EditDailyAllowanceInReport = '/expenses/reports/da/:id/review',
	ExpenseReports = '/expenses/reports',
	ExpenseReportsSubmitted = '/expenses/reports/submitted',
	NewExpenseReport = '/expenses/reports/new',
	EditExpenseReport = '/expenses/reports/:id/review',
	SelectExpensesInReport = '/expenses/reports/:id/select',
	Safety = '/safety/:tab?',
	CreateCompanyInvoices = '/company-onboarding',
	OnboardingConfirmation = '/company-onboarding-confirmation',
	CallbackVerification = '/callback-verification/:tripId/:bookingSegmentToTravelerId',
	CreditCardCallbackVerification = '/card-verification/:cardId/:cardType/:entityId',
	WordlineOrderCallbackVerification = '/order-verification/:orderId',
	BookCustomerSuccessConsultant = '/book-consultant',
}
